import React from 'react';
import { Button } from '../components/ui/button';
import { Wrench, Clock } from 'lucide-react';
import { useMaintenance } from '../contexts/MaintenanceContext';

const MaintenancePage = () => {
  const { maintenanceStatus, checkMaintenanceStatus } = useMaintenance();

  const formatDateTime = (isoString) => {
    if (!isoString) return null;
    const date = new Date(isoString);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full">
        {/* Card Container */}
        <div className="bg-card border rounded-lg p-6 space-y-6 shadow-lg">
          {/* Header with Icon and Title */}
          <div className="flex items-center gap-3">
            <div className="bg-amber-500/10 p-3 rounded-full">
              <Wrench className="h-8 w-8 text-amber-500" />
            </div>
            <h1 className="text-2xl font-bold">Application en Maintenance</h1>
          </div>

          {/* Content */}
          <div className="space-y-4">
            {maintenanceStatus.reason && (
              <div className="space-y-2">
                <p className="text-sm font-medium text-muted-foreground">Raison :</p>
                <p className="text-base">{maintenanceStatus.reason}</p>
              </div>
            )}

            {maintenanceStatus.estimated_end && (
              <div className="flex items-center gap-2 text-muted-foreground">
                <Clock className="h-5 w-5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium">Retour prévu :</p>
                  <p className="text-base">{formatDateTime(maintenanceStatus.estimated_end)}</p>
                </div>
              </div>
            )}
          </div>

          {/* Action Button */}
          <Button
            onClick={checkMaintenanceStatus}
            className="w-full"
            variant="outline"
          >
            Vérifier si la maintenance est terminée
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
